import { PaintedScene } from '../PaintedScene';

export const WOODS_EDGE_PHASER_KEY = 'WoodsEdgeScene' as const;
export const WOODS_EDGE_MANIFEST_KEY = 's-504-woods-edge' as const;

export class WoodsEdgeScene extends PaintedScene {
  constructor() {
    super(WOODS_EDGE_PHASER_KEY, WOODS_EDGE_MANIFEST_KEY);
  }
}
